@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as c;

.shipmentTypeSelect {
  width: 125px;
  flex-shrink: 0;

  @include c.containerMedia(v.$tablet-breakpoint) {
    width: 100%;
  }

  &.error {
    :global(.react-select__control) {
      border-color: v.$palette-red;
      box-shadow: 0 0 0 2px #ffe0e8;
    }
  }
}

.shipmentSelectMenuList {
  max-height: 198px;
}

.globalCarrierSelect {
  width: 169px;
  flex-shrink: 0;

  @include c.containerMedia(v.$tablet-breakpoint) {
    width: 100%;
  }
}

.standaloneCarrierSelect {
  width: 248px;
  flex-shrink: 0;

  @include c.containerMedia(v.$tablet-breakpoint) {
    width: 100%;
  }
}

@keyframes globalCarrierMenuFadeIn {
  0% {
    max-height: 0;
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
  25% {
    opacity: 0;
    transform: translateX(-50%) translateY(-15px);
  }
  100% {
    max-height: 150px;
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

.globalCarrierMenu:global(.react-select__menu) {
  @include c.containerMedia(v.$tablet-breakpoint, "min") {
    width: 248px;
    left: 60% !important;
    top: 105% !important;
    transform: translateX(-50%);
    animation: globalCarrierMenuFadeIn 300ms ease-in-out !important;
  }
}
